// extracted by mini-css-extract-plugin
module.exports = {"tags":"_4L-5AmbCby_DiBRuJhjkn"};